import React from 'react';

const InputField = ({field, onInputChange}) => {
  const {label, type, cssClass, placeholder, isRequired, value} = field;
  return (
    <div className={`form-field ${cssClass}`}>
      <input
        name={label?.toLowerCase()}
        type={type}
        placeholder={placeholder}
        required={isRequired}
        aria-label={placeholder}
        value={value ? value : ''}
        onChange={onInputChange}
      />
    </div>
  );
}

export default InputField;